export const Footer = () => {
  return (
    <footer className="mt-16 pt-6 border-t border-white/10">
      <p className="text-xs text-white/35 leading-relaxed">
        Built and maintained by{" "}
        <span className="text-white/60">Alessandro Branco</span> using{" "}
        <span className="text-white/60">React</span> and{" "}
        <span className="text-white/60">Tailwind CSS</span>. Deployed on{" "}
        <span className="text-white/60">Netlify</span>.
      </p>
    </footer>
  );
};